import { useClientHandle, type UseQueryArgs } from '@urql/vue';

import {
  type EntityQuery as Query,
  type EntityQueryVariables as Variables,
  EntityDocument as Document,
} from '~/graphql/mma/generated/graphql';

export const useEntity = (
  variables: Ref<Variables>,
  options?: Omit<UseQueryArgs<Query, Variables>, 'query' | 'variables'>,
) => useClientHandle().useQuery<Query, Variables>({
  query: Document,
  variables,
  ...options,
});
